export const statusRecipe = {
	RA: 'Receta aprobada',
	RV: 'Receta por verificación',
	RI: 'Receta rechazada',
	NP:'NP'
};
